import {ActionTypes} from "./types";

const INITIAL_STATE = {
  pricings: undefined
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SET_PRICINGS:
      return {
        ...state,
        pricings: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;